<template>
  <div class="page">
    <div class="btns">
      <div class="dusbin" @click="deleteRule(rules.ruleId)"></div>
      <div class="edit" @click="openAddBox(rules.ruleId)"></div>
      <div class="status" :class="rules.startType===1 ? 'active' : ''" @click="startRule(rules.ruleId,rules.startType)">{{ rules.startType===1 ? '已启用' : '启用' }}</div>
    </div>
    <div class="rule-name">{{ rules.ruleName }}</div>
    <div class="channel-type">
      <img src="http://cdn.chinachdu.com/webStatic/pay-platform/heepay.png" />
      <span>{{rules.channel}}</span>
    </div>
    <div class="table-box">
      <div class="th">
        <span class="line1">商户号/商户登录号</span>
        <span class="line2">商户名称</span>
        <span class="line3">分润比</span>
      </div>
      <div class="td" v-for="(item, index) in rules.rulesReqVOList" :key="index" v-show="index < 3">
        <span class="line1">{{ item.accountId }}</span>
        <span class="line2">{{ item.accountName }}</span>
        <span class="line3">{{ item.shareProfit }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RuleBlock',
  inject: ['openAddBox'],
  props: ['rules'],
  methods: {
    deleteRule(ruleId) {
      this.$confirm('此操作将永久分账规则我是规则名称，是否继续？', '删除规则', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$emit('del',ruleId)
      });
    },
    startRule(ruleId,startType){
      this.$emit('start',ruleId,startType)
    },
  },
};
</script>

<style lang="less" scoped>
@import '~@/assets/style/mixins.less';
@import '~@/assets/style/var.less';
.page {
  background-color: #fcfcfc;
  position: relative;
  width: 480px;
  height: 203px;
  margin-top: 10px;
  margin-left: 10px;
  .btns {
    .flex_layout(@justify: flex-end);
    position: absolute;
    top: 10px;
    right: 12px;
    width: 300px;
    height: 38px;
    font-size: 13px;
    color: #999;
    div {
      cursor: pointer;
    }
    .dusbin {
      width: 14px;
      height: 15px;
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/trash-gray.png') center no-repeat;
      background-size: contain;
      margin-right: 10px;
    }
    .dusbin:hover {
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/trash-red.png') center no-repeat;
      background-size: contain;
    }
    .edit {
      width: 12px;
      height: 12px;
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/edit-gray.png') center no-repeat;
      background-size: contain;
      margin-right: 10px;
    }
    .edit:hover {
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/edit-blue.png') center no-repeat;
      background-size: contain;
    }
    .status {
      width: 59px;
      height: 15px;
      line-height: 15px;
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/unselected.png') left no-repeat;
      background-size: 15px 15px;
      text-indent: 20px;
    }
    .active {
      background: url('http://cdn.chinachdu.com/webStatic/pay-platform/selected.png') left no-repeat;
      background-size: 15px 15px;
      color: #4359b7;
    }
  }
  .rule-name {
    line-height: 22px;
    color: #333;
    font-size: 16px;
    margin-top: 20px;
    margin-left: 15px;
    width: 256px;
    height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .channel-type {
    .flex_layout(@justify: flex-start);
    margin: 9px 0 0 15px;
    height: 18px;
    img {
      width: 12px;
      height: 11px;
    }
    span {
      margin-left: 5px;
      color: #333;
      font-size: 13px;
    }
  }
  .table-box {
    margin-left: 51px;
    .th,
    .td {
      span {
        height: 16px;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 15px;
      }
      .line1 {
        width: 131px;
      }
      .line2 {
        width: 182px;
      }
      .line3 {
        width: 40px;
      }
    }
    .th {
      .flex_layout(@justify: flex-start);
      color: #999;
      font-size: 12px;
      margin-top: 8px;
    }
    .td {
      .flex_layout(@justify: flex-start);
      font-size: 14px;
      color: #666;
      margin-top: 12px;
    }
  }
}
</style>
